/**
 * composeFiscalAddress — converts the structured ``fiscal_*`` fields
 * the SAT CSF prompt produces into one readable human line suitable
 * for a free-form "Domicilio" textarea.
 *
 * Why this lives in a helper (not inline in PhaseCompanyData):
 *  - REP and APO phases that also extract from a CSF can reuse it.
 *  - Format is documented in one place; if marketing later asks for a
 *    different style (multi-line, with labels, etc.) we change it
 *    once and every phase follows.
 *
 * Output examples
 * ───────────────
 *   "Av. Insurgentes Sur 1234, Int. 5, Col. Roma Norte, "
 *   "Cuauhtémoc, Ciudad de México, CP 06700"
 *
 *   "Calle Hidalgo S/N, Centro, Querétaro, Querétaro, CP 76000"
 *
 * Missing pieces are silently dropped so we never emit "Calle null,
 * null, null, null, null".
 */

function clean(v) {
  if (v === null || v === undefined) return "";
  const s = String(v).trim();
  // Normalize a few common OCR garbage tokens.
  if (!s || s.toLowerCase() === "null" || s.toLowerCase() === "n/a") return "";
  return s;
}

export default function composeFiscalAddress(d) {
  if (!d) return "";

  const street    = clean(d.fiscal_street);
  const extNum    = clean(d.fiscal_ext_number);
  const intNum    = clean(d.fiscal_int_number);
  const neigh     = clean(d.fiscal_neighborhood);
  const muni      = clean(d.fiscal_municipality);
  const state     = clean(d.fiscal_state);
  const zip       = clean(d.fiscal_zip_code);

  // First segment: street + ext / int. The street field often already
  // includes "Av." / "Calle" / "Calzada" from the prompt, so we don't
  // double-prefix.
  const streetParts = [];
  if (street) streetParts.push(street);
  if (extNum) streetParts.push(extNum);
  const streetLine = streetParts.join(" ");

  const segments = [];
  if (streetLine) segments.push(streetLine);
  if (intNum)     segments.push(`Int. ${intNum}`);
  if (neigh)      segments.push(`Col. ${neigh}`);
  if (muni)       segments.push(muni);
  if (state)      segments.push(state);
  if (zip)        segments.push(`CP ${zip}`);

  return segments.join(", ");
}
